/* el-benefits.js — sections/el-benefits.liquid
   Open one benefit card at a time; clicking the open card closes it. */
(function () {
  'use strict';

  function setOpen(card, open) {
    var toggle = card.querySelector('[data-el-benefit-toggle]');
    var desc = card.querySelector('.el-benefits__desc');
    card.classList.toggle('is-open', open);
    if (toggle) toggle.setAttribute('aria-expanded', open ? 'true' : 'false');
    if (desc) desc.hidden = !open;
  }

  /* Smooth version: the white box slides open / shut (el-accordion-motion.js) */
  function slide(card, open) {
    if (!window.elToggleHeight) { setOpen(card, open); return; }
    window.elToggleHeight(card.querySelector('.el-benefits__box'), card.querySelector('.el-benefits__desc'), function (o) { setOpen(card, o); }, open);
  }

  document.addEventListener('click', function (event) {
    var toggle = event.target.closest('[data-el-benefit-toggle]');
    if (!toggle) return;
    var card = toggle.closest('[data-el-benefit]');
    var section = toggle.closest('[data-el-benefits]');
    if (!card || !section) return;
    var willOpen = !card.classList.contains('is-open');
    section.querySelectorAll('[data-el-benefit].is-open').forEach(function (c) { slide(c, false); });
    if (willOpen) slide(card, true);
  });

  /* Theme editor: open the card being edited */
  document.addEventListener('shopify:block:select', function (event) {
    var card = event.target.closest && event.target.closest('[data-el-benefit]');
    var section = card && card.closest('[data-el-benefits]');
    if (!section) return;
    section.querySelectorAll('[data-el-benefit].is-open').forEach(function (c) { setOpen(c, false); });
    setOpen(card, true);
  });
})();
